<script setup lang="ts">
import type { SensorViewValues } from '../../models/sensorViewValues';
import WaterWidget from '../../widgets/Water';
import { computed } from 'vue';
import type { PropType } from 'vue';
import { convertValue, extractMeta } from '../../utilities/utils';

const props = defineProps({
  viewValues: {
    type: Object as PropType<SensorViewValues>,
    required: true,
  },
});

const temp = computed(() => props.viewValues.values.find((v) => v.type === 'temp'));
const volume = computed(() => props.viewValues.values?.find(v => v.index === 0 && v.type === 'analog'));

const params = computed(() => ({
  temp: convertValue(temp.value),
  volume: convertValue(volume.value),
  meta: extractMeta(props.viewValues)
}));
</script>

<template>
  <WaterWidget v-bind="params" />
</template>
